import { find, filter } from 'lodash';

export default {
  FILTERED_EMPLOYEES: state => {
    const { employees = [] } = state.filters;

    return state.employeesList.filter(employee =>
      employees.includes(employee.id)
    );
  },

  SELECTED_DAY_TASKS: ({ tasks, selectedDay, selectedEntity }) => {
    if (!selectedDay || !selectedEntity) {
      return [];
    }

    return filter(tasks, {
      employee_id: selectedEntity.id,
      date_from: selectedDay.date
    });
  },

  SELECTED_ORDER: ({ order, ordersList }) => {
    if (!order) {
      return null;
    }

    return find(ordersList, { id: order });
  },

  GET_DAY: state => {
    return state.day;
  }
};
